import script from "./Login.vue?vue&type=script&setup=true&lang=js"
export * from "./Login.vue?vue&type=script&setup=true&lang=js"

import "./Login.vue?vue&type=style&index=0&id=12d72883&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d72883"]])

export default __exports__